// extracted by mini-css-extract-plugin
export default {"section":"PaymentMethodsSection_section__ii3JI","list":"PaymentMethodsSection_list__G8z3t","logo":"PaymentMethodsSection_logo__nSVIh"};